export const LeadTypes = Object.freeze({
  EMAIL_ONLY: 1, // email registration only
  FULL: 2, // full registration
})


// WEBPACK FOOTER //
// ./src/includes/leadConstants.js